import React, { Fragment, Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"

import { isEmpty } from "lodash"
import history from "app/history"

import Modal from "react-modal"
import Button from "./Button"
import FormDropdown from "components/form/dropdown"
import { CUSTOM_MODAL_TYPES } from "constants/modal-types"

import { getClassScheduleById, courseEnrollment } from "store/user/actions"
import { amountFormatter } from "helpers/util"

import ErrorIcon from "assets/icons/error.svg"
import SuccessIcon from "assets/icons/success.svg"
// Import styles
import "styles/components/common/response-modal.scss"
import FormRadio from "../form/radio"

class CustomModal extends Component {
  state = {
    selectedClass: 0,
    customModaltype: "",
    compliancePeriod: "",
  }

  componentDidUpdate(prevProps) {
    const { isOpen: prevIsOpen } = prevProps
    const { isOpen } = this.props

    if (!isOpen && isOpen !== prevIsOpen) {
      this.setState({
        compliancePeriod: "",
      })
    }
  }

  handleViewSchedule = (id) => {
    const { getClassScheduleById } = this.props
    getClassScheduleById(id)
  }

  onSelectClass = (id) => {
    this.setState({ selectedClass: id })
  }

  handleSelect = (data) => {
    const { name, value } = data

    this.setState({
      [name]: value,
    })
  }

  handleClassEnrollment = () => {
    const { courseEnrollment, closeModal } = this.props
    const { selectedClass } = this.state

    if (selectedClass !== 0) {
      let courseEnrollmentData = {
        class: selectedClass,
        action: "free",
      }

      courseEnrollment(courseEnrollmentData)
      closeModal()
    }
  }

  handleModalTypeChange = (value) => {
    this.setState({ customModaltype: value })
  }

  handleResendEmail = () => {
    const { handleModalAction, closeModal } = this.props

    handleModalAction()
    closeModal()
  }

  handleFreeEnrollment = () => {
    const { handleModalAction, closeModal } = this.props
    const { compliancePeriod } = this.state
    handleModalAction(compliancePeriod)
    closeModal()
  }

  renderModal(modalType) {
    const {
      data,
      handleModalAction,
      closeModal,
      school: { schoolData },
      user: { compliancePeriod: compliancePeriodOptions },
    } = this.props
    const { config: schoolConfig = {} } = schoolData

    const { selectedClass, customModaltype, compliancePeriod } = this.state

    const hasCompliance = schoolConfig?.products?.mcle

    let type = modalType
    if (
      !isEmpty(customModaltype) &&
      modalType === CUSTOM_MODAL_TYPES.SELECT_CLASS
    ) {
      type = customModaltype
    }

    switch (type) {
      case CUSTOM_MODAL_TYPES.TEXT:
        return (
          <>
            <h1
              className="response-modal-header"
              style={{ color: schoolData.primary_color }}
            >
              {data.name}
            </h1>
            <p className="response-modal-message">
              Enrollment is free! You can access all the course materials and
              you can get your certificate right away.
            </p>
            <div className="response-modal-form">
              {hasCompliance && (
                <div className="compliance-container">
                  <p>Select Compliance Period</p>
                  <FormDropdown
                    horizontal
                    name="compliancePeriod"
                    handleChange={this.handleSelect}
                    options={compliancePeriodOptions}
                    value={compliancePeriod}
                    required={true}
                  />
                </div>
              )}
            </div>
            <div className="button-group">
              <Button
                block
                label="Proceed"
                customClassName="response-modal-button"
                disabled={hasCompliance && !compliancePeriod}
                onClick={
                  isEmpty(customModaltype)
                    ? () => handleModalAction(compliancePeriod)
                    : this.handleClassEnrollment
                }
              />
            </div>
          </>
        )
      case CUSTOM_MODAL_TYPES.COMPLETED:
        return <> COMPLETED</>
      case CUSTOM_MODAL_TYPES.RATING:
        return <> RATING</>
      case CUSTOM_MODAL_TYPES.NOT_STUDENT:
        return (
          <Fragment>
            <span className="response-modal-icon">
              <img src={ErrorIcon} alt="FAILED" />
            </span>
            <h2 className={`response-modal-header error`}>Invalid Account</h2>
            <p className="response-modal-message">
              You can't enroll using this account. Please register as a student
              by clicking the Sign Up button.
            </p>
            <div className="button-group">
              <Button label="OK" onClick={closeModal} />
            </div>
          </Fragment>
        )
      case CUSTOM_MODAL_TYPES.VERIFY_EMAIL:
        return (
          <Fragment>
            <span className="response-modal-icon">
              <img src={ErrorIcon} alt="FAILED" />
            </span>
            <h2 className={`response-modal-header error`}>
              Oops! Your email is not yet verified.
            </h2>
            <p className="response-modal-message">
              Please open your email and check for a message with subject:{" "}
              <strong>Apptitude: Email Verification.</strong> If it's not in the
              inbox. please check your spam folder. If there is no such email,
              click the button below.
            </p>
            <div className="button-group">
              <Button label="Resend Email" onClick={this.handleResendEmail} />
            </div>
          </Fragment>
        )
      case CUSTOM_MODAL_TYPES.INC_PROFILE:
        return (
          <Fragment>
            <span className="response-modal-icon">
              <img src={ErrorIcon} alt="FAILED" />
            </span>
            <h2 className={`response-modal-header error`}>
              Incomplete Profile
            </h2>
            <p className="response-modal-message">
              Please complete your profile before you can start.
            </p>
            <div className="button-group">
              <Button label="Cancel" onClick={closeModal} ghost />
              <Button label="Go to your profile" onClick={handleModalAction} />
            </div>
          </Fragment>
        )
      case CUSTOM_MODAL_TYPES.INC_MCLE_PROFILE:
        return (
          <Fragment>
            <span className="response-modal-icon">
              <img src={ErrorIcon} alt="FAILED" />
            </span>
            <h2 className={`response-modal-header error`}>
              Incomplete MCLE Profile
            </h2>
            <p className="response-modal-message">
              Please complete your MCLE profile before you can start with your
              enrollment.
            </p>
            <div className="button-group">
              <Button label="Cancel" onClick={closeModal} ghost />
              <Button
                label="Go to your MCLE profile"
                onClick={handleModalAction}
              />
            </div>
          </Fragment>
        )
      case CUSTOM_MODAL_TYPES.INC_KYC:
        return (
          <>
            <span className="response-modal-icon">
              <img src={ErrorIcon} alt="FAILED" />
            </span>
            <h2 className={`response-modal-header error`}>KYC Not Submitted</h2>
            <p className="response-modal-message">
              Please comply with the KYC requirements in order to continue.
            </p>
            <div className="button-group">
              <Button label="Cancel" onClick={closeModal} ghost />
              <Button label="Proceed with KYC" onClick={handleModalAction} />
            </div>
          </>
        )
      case CUSTOM_MODAL_TYPES.COURSE_ENDED:
        return (
          <>
            <span className="response-modal-icon">
              <img src={ErrorIcon} alt="FAILED" />
            </span>
            <h2 className={`response-modal-header error`}>Course Ended</h2>
            <p className="response-modal-message">
              Course ended last {data.config.date_end}.
            </p>
            <div className="button-group">
              <Button label="OK" onClick={closeModal} />
            </div>
          </>
        )
      case CUSTOM_MODAL_TYPES.COURSE_NOT_OPEN:
        return (
          <>
            <span className="response-modal-icon">
              <img src={ErrorIcon} alt="FAILED" />
            </span>
            <h2 className={`response-modal-header error`}>
              Course is not yet open
            </h2>
            <p className="response-modal-message">
              Course will be accessible on {data.config.date_start}.
            </p>
            <div className="button-group">
              <Button label="OK" onClick={closeModal} />
            </div>
          </>
        )
      case CUSTOM_MODAL_TYPES.NO_CLASS:
        return (
          <>
            <span className="response-modal-icon">
              <img src={ErrorIcon} alt="FAILED" />
            </span>
            <h2 className={`response-modal-header error`}>Oops!</h2>
            <p className="response-modal-message">
              There are no classes available. Please try again later or you may
              contact the school admin at schooladmin@yahoo.com
            </p>
            <div className="button-group">
              <Button label="OK" onClick={closeModal} />
            </div>
          </>
        )
      case CUSTOM_MODAL_TYPES.SELECT_CLASS:
        return (
          <>
            <h2
              className={`response-modal-header`}
              style={{ color: schoolData.primary_color }}
            >
              Select Class
            </h2>
            <div className="schedule-container">
              <div className="titles-wrapper">
                <p className="title">Class Name</p>
                <p className="title">Class Fee</p>
                <p className="title">Schedule</p>
              </div>
              <div className="schedule-list">
                {data.classes?.map((item, i) => (
                  <div className="schedule-item" key={i}>
                    <FormRadio
                      type="radio"
                      name="radio-choices"
                      value={selectedClass}
                      checked={selectedClass === item.id}
                      onChange={() => this.onSelectClass(item.id)}
                      id={item.id}
                      text={item.name}
                    />
                    <p className="fee">
                      {item.fee ? `PHP ${amountFormatter(item.fee)}` : "Free"}
                    </p>
                    <Button
                      label="View Class"
                      outlined
                      onClick={() => this.handleViewSchedule(item.id)}
                    />
                  </div>
                ))}
              </div>
              <Button
                disabled={selectedClass === 0}
                label="Join this class"
                onClick={() =>
                  data?.fee > 0
                    ? history.push(
                        `/course/payment/${data.slug}?class=${selectedClass}`
                      )
                    : this.handleModalTypeChange(CUSTOM_MODAL_TYPES.TEXT)
                }
              />
            </div>
          </>
        )
      case CUSTOM_MODAL_TYPES.ANNOUNCEMENT:
        return (
          <div className="container">
            <span
              className={`header`}
              style={{ color: schoolData.primary_color }}
            >
              ANNOUNCEMENT
            </span>
            <p div className="alert">
              To All Lawyers Currently Attending ChanRobles’ Online MCLE
              Courses:
            </p>
            <div className="message">
              <div className="body-copy">
                <p>
                  Please be advised that, consistent with the directive of the
                  MCLE Office, we have reshot and re-edited the lecture videos
                  for all of our MCLE Online courses in order to better comply
                  with requirements on interactive contents (i.e., pop-up
                  questions, graphics interactions, etc.), as imposed by the
                  Implementing Guidelines of the Rules and Regulations in the
                  Conduct of MCLE Online (MCLE Governing Board Resolution No.
                  04-2020).
                </p>
                <p>
                  We are pleased to announce that the new lecture videos for
                  five (5) of our courses have already been approved by the MCLE
                  Office, particularly:
                  <br />
                </p>
                <table>
                  <thead>
                    <tr>
                      <th>Topic</th>
                      <th>Lecturer</th>
                      <th>Credit units</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Advanced Oral Advocacy Skills in the Courtroom</td>
                      <td>LEB COM. ZENAIDA ELEPANO</td>
                      <td>2</td>
                    </tr>
                    <tr>
                      <td>Competition Law Compliance in Contracting</td>
                      <td>ATTY. MA. LEAH JOSE-SEBASTIAN</td>
                      <td>2</td>
                    </tr>
                    <tr>
                      <td>Finality of Arbitral Awards</td>
                      <td>ATTY. ARTHUR P. AUTEA</td>
                      <td>3</td>
                    </tr>
                    <tr>
                      <td>Pre-Trial and Judicial Affidavit Rule as Amended</td>
                      <td>LEB COM. ZENAIDA ELEPANO</td>
                      <td>2</td>
                    </tr>
                    <tr>
                      <td>Advanced Cross-Examination</td>
                      <td>DEAN JOSE MANUEL I. DIOKNO</td>
                      <td>2</td>
                    </tr>
                  </tbody>
                </table>

                <p>
                  <br />
                </p>

                <p>
                  Said new lecture videos shall be available for viewing
                  starting at 6:00 a.m., on 11 September 2021 while the current
                  lecture videos on the same subject shall remain online until
                  11:59 p.m. of 10 September 2021.
                </p>
                <p>&nbsp;</p>
                <p>
                  For those who desire to view the current lecture videos for
                  the said courses during the next four (4) days (i.e., 7 to 10
                  September 2021), kindly make sure that you have enough time to
                  complete viewing the said videos on or before 11:59 p.m. of 10
                  September 2021.
                </p>
                <p>&nbsp;</p>
                <p>
                  The current lecture videos for the said courses shall be
                  pulled-out by 12 midnight on 10 September 2021 to give way to
                  the new lecture videos for the said courses. If you have not
                  completed your viewing of the current lecture videos for the
                  said courses by 11:59 p.m. on 10 September 2021, the view logs
                  for the said courses shall be reset back to zero (0) upon the
                  pull-out of the current lecture videos, and you will need to
                  watch the new lecture videos from the start to earn your
                  credit units for the said course(s).
                </p>
                <p>&nbsp;</p>
                <p>
                  If you are not certain that you have enough time to completely
                  watch the current lecture videos for the subject courses by
                  11:59 p.m. of 10 September 2021, it may be more prudent for
                  you to just wait for the availability of new lecture videos
                  starting at 6:00 a.m. on 11 September 2021.
                </p>
                <p>&nbsp;</p>
                <p>
                  Please be guided accordingly.
                  <br />
                </p>
              </div>
              <div style={{ textAlign: "center", marginTop: "8px" }}>
                <Button label="Okay" onClick={() => closeModal()} />
              </div>
            </div>
          </div>
        )
      case CUSTOM_MODAL_TYPES.PAY_LATER:
        return (
          <>
            <span className="response-modal-icon">
              <img src={SuccessIcon} alt="SUCCESS" />
            </span>
            <h2 className={`response-modal-header success`}>Enroll for Free</h2>
            <p className="response-modal-message">
              You can access all modules and their contents for free but no
              certificate will be issued unless paid.
            </p>
            <div className="response-modal-form">
              {hasCompliance && (
                <div className="compliance-container">
                  <p>Select Compliance Period</p>
                  <FormDropdown
                    horizontal
                    name="compliancePeriod"
                    handleChange={this.handleSelect}
                    options={compliancePeriodOptions}
                    value={compliancePeriod}
                    required={true}
                  />
                </div>
              )}
            </div>
            <div className="button-group">
              <Button
                block
                label="Proceed"
                customClassName="response-modal-button"
                disabled={hasCompliance && !compliancePeriod}
                onClick={() => this.handleFreeEnrollment()}
              />
            </div>
          </>
        )
      default:
    }
  }
  render() {
    const { isOpen, closeModal, type } = this.props

    return (
      <Modal
        closeTimeoutMS={1000}
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel={type}
        ariaHideApp={false}
        className="response-modal full"
        overlayClassName="response-modal-overlay"
      >
        <Fragment>
          <div className="response-modal-container">
            {this.renderModal(type)}
          </div>
        </Fragment>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  school: state.schoolReducer,
  user: state.userReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getClassScheduleById, courseEnrollment }, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(CustomModal)
